export enum RepostType {
    manual = 0,
    repost = 1,
}

export interface ManualRepostObject {
    projectId: string;
    addMethod: RepostType;
    dateTime?: Date;
}export enum RepostType {
    manual = 0,
    repost = 1,
}

export interface ManualRepostObject {
    projectId: string;
    addMethod: RepostType;
    dateTime?: Date;
}